import { render, staticRenderFns } from "./onlineUsers.vue?vue&type=template&id=2b2a1348&scoped=true&"
import script from "./onlineUsers.vue?vue&type=script&lang=js&"
export * from "./onlineUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a1348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b2a1348')) {
      api.createRecord('2b2a1348', component.options)
    } else {
      api.reload('2b2a1348', component.options)
    }
    module.hot.accept("./onlineUsers.vue?vue&type=template&id=2b2a1348&scoped=true&", function () {
      api.rerender('2b2a1348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/onlineUsers.vue"
export default component.exports